/** @type {{ cancel: () => void, isActive: () => boolean } | null} */
let activeSession = null;

export function registerGuidedWorkflow(session) {
  activeSession = session;
}

export function unregisterGuidedWorkflow(session) {
  if (activeSession === session) {
    activeSession = null;
  }
}

export function isGuidedWorkflowActive() {
  return Boolean(activeSession?.isActive?.());
}

export function dismissGuidedWorkflow() {
  activeSession?.cancel?.();
}
